import getLocal from '@/app/utils/getLocal';
import classNames from 'classnames';
import EFPicture from 'elem/ui/ef-picture';
import React from 'react';
import { Navigation, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import './index.scss';
import { langText } from './langText';

export interface EfBlogItemProps {
    /**
     * 标题
     */
    title: string;
    /**
     * 链接
     */
    link?: string;
    /**
     * 图片
     */
    img: string;
}
interface EfBlogListsProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * 段落标题
     */
    title: string;
    /**
     * 列表
     */
    lists: EfBlogItemProps[];
}

/**
 * 维护: Kalkin
 *
 * 博客列表
 */
const EfBlogLists: React.FC<EfBlogListsProps> = ({ lists = [], title, className }) => {
    const { locale = 'us' } = getLocal();
    const i18n = langText[locale] || langText['us'];
    const prefixCls = `ef-blog-lists`;
    const [gap, setGap] = React.useState(24);
    const classes = classNames(prefixCls, 'ef-container', {
        [`${className}`]: className,
    });

    React.useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
        }
    }, []);

    return (
        <div className={classes}>
            <p className={`${prefixCls}-title`}>{title}</p>
            <Swiper
                className={`${prefixCls}-swiper-box`}
                // effect="fade"
                modules={[Scrollbar, Navigation]}
                spaceBetween={gap}
                // centeredSlides={true}
                navigation={lists?.length > 1}
                slidesPerView={'auto'}
                initialSlide={0}
                scrollbar={{
                    hide: false,
                    draggable: true,
                    dragSize: 32,
                    snapOnRelease: true,
                }}
            >
                {lists?.map((card: any, k: number) => (
                    <SwiperSlide className={`${prefixCls}-swiper-item ${prefixCls}-item-${k + 1}`} key={k}>
                        <EFPicture className={`${prefixCls}-card-img`} src={card?.img} alt={card.title} />
                        <div className={`${prefixCls}-card-info`}>
                            <p className={`${prefixCls}-card-title`}>{card?.title}</p>
                            {card?.link && (
                                <a className={`${prefixCls}-card-link`} href={card?.link} target="_blank" rel="noreferrer">
                                    <span className={`${prefixCls}-link-text`}>{i18n.link_more}</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                        <path
                                            d="M6.50006 12.3291L10.5001 8.3291L6.50006 4.3291"
                                            stroke="#2673FF"
                                            strokeWidth="1.33333"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </a>
                            )}
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default EfBlogLists;
